/**
 * Created by spepa on 01.11.2022
 */

const UnitLibraryIconBg = cc.Node.extend({
    ctor: function (unit) {
        this._super();
        this.setAnchorPoint(0.5, 0.5);

        this.unit = unit;
        this.closed = !cleverapps.unitsLibrary.isOpened(this.unit);

        this.createBackground();

        if (unit.selected) {
            this.createSelectedBackground();
        }

        this.setContentSize(
            Math.max(this.background.width, this.selectedBackground && this.selectedBackground.width || 0),
            this.background.height
        );

        this.createIcon();
        this.createPassIcon();
        this.createFeedIcon();
        this.createTitle();
        const searchIcon = bundles.unitslibrarywindow.frames.search_icon;
        if (this.closed
            && (unit.stage === 0 || cleverapps.unitsLibrary.isOpened({ code: unit.code, stage: unit.stage - 1 }))
            && searchIcon && searchIcon.resolve()
            && UnitsLibrary.codesByTabId[cleverapps.meta.selectedLocationId()][1].includes(unit.code)
        ) {
            this.addFindIcon();
        }
        if (!unit.unmergeable) {
            this.createNextArrow();
        }
    },

    createBackground: function () {
        const styles = cleverapps.styles.UnitLibraryIconBg;

        let frame = bundles.merge.frames.icon_background_light;

        if (bundles.merge.frames.icon_background_unknown && this.unit.unknown) {
            frame = bundles.merge.frames.icon_background_unknown;
        }
        
        const background = this.background = new cc.Scale9Sprite(frame);
        background.setContentSize2(styles);
        background.setAlignment({ align: "center" }, { align: "center" });
        this.addChild(background);
    },

    createSelectedBackground: function () {
        const styles = cleverapps.styles.UnitLibraryIconBg;

        if (!styles.selected) {
            return;
        }

        const selectedBackground = this.selectedBackground = new cc.Scale9Sprite(bundles.merge.frames.icon_background_selected);
        selectedBackground.setContentSize2(styles.selected);
        selectedBackground.setLocalZOrder(-1);
        selectedBackground.setAlignment({ align: "center" }, { align: "center" });
        this.addChild(selectedBackground);

        if (styles.selected.backgroundDisabled) {
            this.background.setVisible(false);
        }
    },

    createNextArrow: function () {
        const styles = cleverapps.styles.UnitLibraryIconBg;

        if (!styles.nextArrow || this.unit.last) {
            return;
        }

        const frame = this.unit.unknown && bundles.merge.frames.next_arrow_unknown_png
            || bundles.merge.frames.next_arrow_png;

        const arrow = new cc.Sprite(frame);
        arrow.setAlignment(styles.nextArrow);
        this.addChild(arrow);
    },

    createIcon: function () {
        const styles = cleverapps.styles.UnitLibraryIconBg;
        const icon = this.icon = UnitView.getUnitImage(this.unit, { useLibraryAnchors: true, preferStatic: true });
        cleverapps.UI.fitToBox(icon, styles.icon);
        icon.setAlignment(this.width / 2 + styles.icon.x, this.height / 2 + styles.icon.y);
        this.addChild(icon);

        if (this.unit.unknown) {
            cleverapps.UI.fitToBox(icon, styles.iconUnknown);
            icon.setAlignment(styles.iconUnknown);
        } else if (this.closed) {
            if (icon instanceof LazyAsset) {
                icon.whenAssetLoaded(() => {
                    if (icon.asset) {
                        cleverapps.UI.convertToGrayShape(icon.asset);
                    }
                });
            } else {
                cleverapps.UI.convertToGrayShape(icon);
            }
        }
    },

    addFindIcon: function () {
        const styles = cleverapps.styles.UnitLibraryIconBg.findIcon;
        this.findIcon = new cc.Sprite(bundles.unitslibrarywindow.frames.search_icon);
        this.addChild(this.findIcon);
        this.findIcon.setAlignment(styles);
        cleverapps.UI.onClick(this.findIcon, () => {
            const actions = [
                (f) => {
                    cleverapps.focusManager.currentWindow().close();
                    cleverapps.focusManager.whenFreeFocus(f);
                },
                (f) => {
                    const unitCode = this.unit.code;
                    const locatorTypeConfig = UnitsLibrary.UNIT_LOCATOR_TYPE_BY_EXPEDITION[cleverapps.meta.selectedLocationId()];
                    const findOptions = {
                        useStageForCustomerSearch: true,
                        allowScrollWithFocus: true,
                        tryAdvice: true,
                        searchFakeSources: true
                    };
                    if (Families[unitCode].locators) {
                        findOptions.getFindTargets = function () {
                            return Families[unitCode].locators;
                        };
                    }
                    UnitLocator.find(locatorTypeConfig && locatorTypeConfig[unitCode] || Map2d.SPAWN, this.unit, findOptions);
                    f();
                }
            ];
            const player = new ActionPlayer(actions);
            player.play();
        });
    },

    createTitle: function () {
        const styles = cleverapps.styles.UnitLibraryIconBg.title;
        if (!styles) {
            return;
        }

        let text = cleverapps.unitsLibrary.getUnitName(this.unit);
        text = cleverapps.splitHalfByWord(text).join("\n");

        const title = this.title = cleverapps.UI.generateOnlyText(text, cleverapps.styles.FONTS.UNITICON_TITLE);
        title.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        title.fitTo(styles.width, styles.height);
        title.setAlignment(styles);
        this.addChild(title);

        if (this.closed) {
            title.setCascadeOpacityEnabled(true);
            title.setCascadeColorEnabled(true);
            title.setOpacity(120);
        }
    },

    createPassIcon: function () {
        if (this.unit.unknown) {
            return;
        }

        if (!Families[this.unit.code].units[this.unit.stage].bpPoints) {
            return;
        }

        const styles = cleverapps.styles.UnitLibraryIconBg;

        const mission = cleverapps.missionManager.findLocalPass();
        if (mission) {
            const icon = new cc.Sprite(cleverapps.skins.getSlot("pass_star_png") || bundles.reward_icons_pass.frames.pass_star_png);
            icon.setAlignment(styles.passIcon);
            this.addChild(icon);
        }
    },

    createFeedIcon: function () {
        if (this.unit.unknown) {
            return;
        }
        const unitData = Families[this.unit.code].units[this.unit.stage];
        if (!unitData.feedable || !["clpet", "clpetrare", "clpetlegend"].includes(Families[this.unit.code].type)) {
            return;
        }

        const icon = new cc.Sprite(bundles.merge.frames.feedable_icon);
        icon.setAlignment(cleverapps.styles.UnitLibraryIconBg.feedIcon);
        this.addChild(icon);
    },

    updateStatus: function () {
        this.icon.setVisible(!cleverapps.unitsLibrary.isFresh(this.unit));

        this.updatePrize();

        if (this.closed && cleverapps.unitsLibrary.isOpened(this.unit)) {
            this.closed = false;
            this.icon.setOpacity(255);
            this.icon.setColor(cleverapps.styles.COLORS.WHITE);
            this.title && this.title.setOpacity(255);
            this.title && this.title.setColor(cleverapps.styles.COLORS.WHITE);
        }
    },

    updatePrize: function () {
        const styles = cleverapps.styles.UnitLibraryIconBg;
        const fresh = cleverapps.unitsLibrary.isFresh(this.unit);

        if (fresh && !this.prize) {
            this.prize = new UnitLibraryIconPrize();
            this.prize.setAlignment(styles.prize || this.icon.getPosition());
            this.addChild(this.prize);
        } else if (!fresh && this.prize) {
            this.prize.openAnimation();
            delete this.prize;
        }
    }
});

cleverapps.styles.UnitLibraryIconBg = {
    width: 178,
    height: 175,

    selected: {
        width: 198,
        height: 195
    },

    icon: {
        x: 0,
        y: 0,
        width: 160,
        height: 160,
        maxScale: 1.3
    },

    iconUnknown: {
        x: { align: "center" },
        y: { align: "center", dy: -25 }
    },

    title: {
        x: { align: "center" },
        y: { align: "center", dy: 110 },
        width: 200,
        height: 100
    },

    passIcon: {
        x: { align: "left", dx: -10 },
        y: { align: "bottom", dy: 10 }
    },

    feedIcon: {
        x: { align: "right", dx: -13 },
        y: { align: "bottom", dy: 17 }
    },

    findIcon: {
        x: { align: "right", dx: 10 },
        y: { align: "top", dy: 15 }
    }
};